import * as ProfileTypes from '../profileTypes';

export enum Citizenship {
    "US Citizen" = "US_CITIZEN",
    "Legal Alien (Allowed To Work)" = "LEGAL_ALIEN_ALLOWED_TO_WORK",
    "Legal Alien (NOT Allowed To Work)" = "LEGAL_ALIEN_NOT_ALLOWED_TO_WORK",
    "Other" = "OTHER",
}
  
  /*
   * Form data
   */
export interface FormData {
    firstName: string;
    middleName: string;
    lastName: string;

    dateOfBirth: string;

    sex: ProfileTypes.Sex;

    birthCity: string;
    birthState: string;

    fatherName: string;
    fatherMaidenName: string;
    fatherSocialSecurityNumber?: string;

    motherName: string;
    motherMaidenName: string;
    motherSocialSecurityNumber?: string;

    previousSocialSecurityNumber: string;
    previouslyAppliedForCard: ProfileTypes.YesNoUnknown;

    useCareProviderAddressForMailing: boolean;
    mailingAddress?: ProfileTypes.Address;

    citizenship: Citizenship;

    equifaxConsent: boolean;
}